import React from 'react';
import styles from './medicalForm.module.css';

import ActivePageIndicator from '../activePageIndicator/activePageIndicator';
import QuestionContainer from '../questionContainer/questionContainer';

const MedicalForm = ({
    activePage,
    questions,
    toggleCheckbox,
    setPickedRadioButton,
}) => (
    <div className={styles.pagedForm}>
        <div className={styles.formPages}>
            <QuestionContainer
                question={questions[activePage]}
                onCheckboxChange={toggleCheckbox}
                onRadioButtonChange={setPickedRadioButton}
            />
        </div>
        <div className={styles.navigationBar}>
            <ActivePageIndicator
                activePage={activePage}
                pagesCount={questions.length}
            />
        </div>
    </div>
);

export default MedicalForm;
